import authApi from '@api/authApi';
import { ErrorDetails } from '@models/errorDetails';
import ky from 'ky';

export class NetworkError extends Error {
  constructor(
    public readonly url: string,
    cause: unknown,
  ) {
    super(`Could not fetch ${url}`, { cause });
  }
}

declare module 'ky' {
  interface HTTPError {
    text: string;
    details?: ErrorDetails;
  }
}

export const baseApi = ky.extend({
  prefixUrl: `${config.BACKEND}/api`,
  timeout: 60_000,
  retry: 3,
  async fetch(input, init) {
    try {
      return await fetch(input, init);
    } catch (error) {
      const url = typeof input === 'string' ? input : input instanceof URL ? input.toString() : input.url;
      throw new NetworkError(url, error);
    }
  },
  hooks: {
    beforeError: [
      async (error) => {
        const { request, response } = error;
        const text = await response.text().catch(() => '');
        const messageLength = error.message.length;

        error.text = text;
        try {
          error.details = ErrorDetails.parse(JSON.parse(text));
        } catch {
          // ignore
        }

        error.message = [error.message, text, `${request.method} ${request.url}`].filter(Boolean).join('\n');

        if (error.stack) {
          error.stack = error.message + error.stack.slice(messageLength);
        }

        return error;
      },
    ],
  },
});

export const api = baseApi.extend({
  hooks: {
    beforeRequest: [
      async (request) => {
        const auth = await authApi.auth.get();

        if (!auth) {
          throw new Error('Not authenticated');
        }

        request.headers.set('Authorization', `Bearer ${auth.accessToken}`);
      },
    ],
  },
});

export default api;
